<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Logicflow',
})
</script>
<template>
  <div class="Logicflow">
    <!-- <a-button type="primary" style="margin:10px 0" @click="onSaveFlowData">保存</a-button> -->
    <LogicFlow ref="logicFlowRef" @parentNodes="onSetParentNodes" :flowData="flowData" />
  </div>
</template>
<script lang='ts' setup name="Logicflow">
import { ref } from 'vue'
import LogicFlow from '@/components/LogicFlow/index.vue'
const logicFlowRef = ref()
const onSaveFlowData = () => {
  const data = logicFlowRef.value.getFlowJson()
  console.log(data)
}
const onSetParentNodes = data => {
  console.log(data)
}

const flowData = {
  "nodes": [
  ]
}

</script>
<style lang='less'>
.Logicflow {}
</style>
